import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=e4ec79ce&scoped=true&"
import script from "./Discounts.vue?vue&type=script&lang=js&"
export * from "./Discounts.vue?vue&type=script&lang=js&"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=e4ec79ce&prod&scoped=true&lang=css&"
import style1 from "./Discounts.vue?vue&type=style&index=1&id=e4ec79ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ec79ce",
  null
  
)

export default component.exports